import { configureApiEntity } from '../adapter/index';
import { schema } from 'normalizr';

export const giftcardSchema = new schema.Entity('giftcards');

export const giftcards = configureApiEntity('GIFTCARDS', 'giftcards', giftcardSchema);
